import { render } from "./PaymentViewComponent.vue?vue&type=template&id=dd61bb6e"
import script from "./PaymentViewComponent.vue?vue&type=script&lang=js"
export * from "./PaymentViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__